exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bookmark-icon-green{color:#0a86ff!important}.search-loading-spinner{width:25px;height:25px}body{background:#fff!important;overflow-x:hidden!important}.breadcrumb-button{background-color:#fff!important;border:1px solid #000!important;z-index:10;color:#000!important;font-weight:700!important;max-width:18rem!important;white-space:nowrap}", ""]);

// exports
